import {
  SUPPLIER_RETURN_DOC_NUMBER_FILTER,
  SUPPLIER_RETURN_DOC_NUMBER_INV_FILTER,
  SUPPLIER_RETURN_DOC_NUMBER_REF_FILTER,
} from "../constants/ActionTypes";

const INIT_STATE = {
  docNumberFilter: "",
  docNumberInvFilter: "",
  docNumberRefFilter: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SUPPLIER_RETURN_DOC_NUMBER_FILTER: {
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    }

    case SUPPLIER_RETURN_DOC_NUMBER_INV_FILTER: {
      return {
        ...state,
        docNumberInvFilter: action.payload,
      };
    }

    case SUPPLIER_RETURN_DOC_NUMBER_REF_FILTER: {
      return {
        ...state,
        docNumberRefFilter: action.payload,
      };
    }

    default:
      return state;
  }
};
